import { CheckCircleOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { DefectReportStatus } from 'business/quality-control/pages/defect-report-history/hooks/data/types';

const { Title } = Typography;

export enum HeaderType {
  'defect',
  'repair',
}

export const ReportHeader = ({
  status,
  type,
}: {
  status: DefectReportStatus;
  type: HeaderType;
}) => {
  const { t } = useTranslation();

  const title =
    type === HeaderType.defect
      ? 'qualityControl.defectReportHistory.drawer.defect'
      : 'qualityControl.defectReportHistory.drawer.repair';

  return (
    <Flex align="center" gap={8}>
      <CheckCircleOutlined
        style={{
          color:
            (type === HeaderType.defect &&
              status === DefectReportStatus.ReportPending) ||
            (type === HeaderType.repair &&
              status === DefectReportStatus.RepairInProgress)
              ? '#666666'
              : '#01AB61',
        }}
      />
      <Title level={5} style={{ margin: 0 }}>
        {t(title)}
      </Title>
    </Flex>
  );
};
